import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=63cd501a&scoped=true&"
import script from "./forum.vue?vue&type=script&lang=js&"
export * from "./forum.vue?vue&type=script&lang=js&"
import style0 from "./forum.vue?vue&type=style&index=0&id=63cd501a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd501a",
  null
  
)

export default component.exports